import React from "react";
import Image from "next/image";
import Calendar from "@/assets/Icons/calendar";
import Link from "next/link";
import { cleanHTML, formatDateHuman } from "@/lib/utils";

type CardNewsProps = {
  image: string; // url image (bisa dari public atau url external)
  date: string;
  category: string;
  title: string;
  description: string;
  href: string;
};

const CardNews = ({
  image,
  date,
  category,
  title,
  description,
  href,
}: CardNewsProps) => {
  return (
    <div className="flex flex-col gap-4 rounded-xl overflow-hidden bg-white shadow-md">
      <div className="h-[250px] w-full">
        <Image
          alt="news image"
          src={image}
          width={500}
          height={500}
          className="h-full w-full object-cover"
        />
      </div>
      <div className="flex items-center justify-between px-3">
        <div className="flex gap-2 items-center">
          <Calendar />
          <div className="text-[#70707B] font-medium">
            {formatDateHuman(date)}
          </div>
        </div>
        <div className="p-1 bg-[#FCE3BB] rounded-full px-2 text-sm">
          {category}
        </div>
      </div>
      <div className="flex flex-col gap-2 px-3 pb-4">
        <div className="font-semibold text-lg md:text-xl">{title}</div>
        <div
          className="line-clamp-3 text-[#70707B] text-justify text-sm md:text-base"
          dangerouslySetInnerHTML={{ __html: cleanHTML(description) }}
        />
        <div className="flex justify-end w-full mt-2">
          <Link
            href={href}
            className="bg-white hover:bg-slate-100 transition-all duration-150 p-2.5 px-4 border border-[#C7C7CD] text-sm md:text-base text-primary w-fit rounded-full"
          >
            Lihat Selengkapnya
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CardNews;
